import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, zIndex, breakpoints }) => ({
  root: {
    zIndex: zIndex.drawer - 1,
    position: "fixed",
    display: "flex",
    bottom: 0,
    transition: "all 0.25s ease-out",
    [breakpoints.up("md")]: {
      margin: spacing(0, 7)
    },
    [breakpoints.down("sm")]: {
      // old design specific stuff
      marginLeft: "50px !important"
    }
  },
  invisibleAll: {
    transform: "translateY(100%)",
    transition: "all 0.5s ease-in"
  },
  layoutShift: {
    bottom: "66px"
  }
}))
